import PropTypes from 'prop-types';
import React, { useRef, useCallback } from 'react';

import cls from 'classnames';

import { DropdownTrigger } from '@ott/dropdown-next-deprecated';
import { InputWithRef as Input } from '@ott/input-next-deprecated';

import Loader from './blocks/Loader/Loader';

export default function AutocompleteTrigger(props) {
  const {
    onChange,
    onFocus,
    closeOverlay,

    isOpen,
    isFocused,
    isLoading,
    isMobileLayout,
    isMobileInput,
    option,
    className,
    maskTextRenderer,
    OverlayInfoRenderer,
    TriggerRenderer,
    autoSelectOnFocus,
    setOpenState,
    shouldRenderAirportCity,

    onText,
    onSearch,

    ...inputProps
  } = props;

  const inputRef = useRef(null);

  const onInputFocus = useCallback(
    (event) => {
      if (onFocus) {
        onFocus(event);
      }
      if (!isMobileLayout && autoSelectOnFocus && inputRef.current) {
        inputRef.current.select();
      }
    },
    [inputRef, onFocus, autoSelectOnFocus]
  );

  const onInputChange = useCallback(
    (value) => {
      onChange(value);
      if (!isOpen && setOpenState) {
        setOpenState(true);
      }
    },
    [isOpen, onChange, setOpenState]
  );

  const mask = maskTextRenderer ? maskTextRenderer(props) : null;
  const overlayInfo = OverlayInfoRenderer ? <OverlayInfoRenderer {...props} /> : null;
  const readOnly = isMobileLayout && !isMobileInput;

  return (
    <>
      <Input
        ref={inputRef}
        onFocus={onInputFocus}
        onChange={readOnly ? null : onInputChange}
        value={inputProps.value}
        className={className}
        mask={mask}
        type="text"
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
        data-error-placement="top"
        readOnly={readOnly}
        {...inputProps}
      >
        {overlayInfo}
      </Input>
      {isOpen && <Loader isLoading={isLoading} isMobileLayout={isMobileLayout} />}
    </>
  );
}

function defaultMaskRenderer({ option }) {
  return (option && option.name) || '';
}

AutocompleteTrigger.defaultProps = {
  ...DropdownTrigger.defaultProps,
  maskTextRenderer: defaultMaskRenderer,
  autoSelectOnFocus: false,
};

AutocompleteTrigger.propTypes = {
  ...DropdownTrigger.propTypes,
  maskTextRenderer: PropTypes.func,
  OverlayInfoRenderer: PropTypes.func,
  autoSelectOnFocus: PropTypes.bool,
  value: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  option: PropTypes.object,
  isLoading: PropTypes.bool,
  isMobileLayout: PropTypes.bool,
};
